import { InputAdornment, TextField } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";

interface Props {
	value: string;
	onChange: (text: string) => void;
	label: string;
}

export const SearchTextField = ({ value, onChange, label }: Props) => {
	return (
		<TextField
			fullWidth
			variant="outlined"
			placeholder={label}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			size="small"
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon />
					</InputAdornment>
				),
			}}
		/>
	);
};
